// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5); /* Darker transparent background for elegance */
    z-index: 9999;
  }
  
  .loader {
    display: flex;
    gap: 10px; /* Space between dots */
  }
  
  .loader span {
    width: 20px;
    height: 20px;
    background-color: #3498db; /* Loader color */
    border-radius: 50%;
    animation: pulse 1.5s infinite ease-in-out;
  }
  
  .loader span:nth-child(1) {
    animation-delay: 0s;
  }
  .loader span:nth-child(2) {
    animation-delay: 0.2s;
  }
  .loader span:nth-child(3) {
    animation-delay: 0.4s;
  }
  
  @keyframes pulse {
    0%, 80%, 100% {
      transform: scale(0); /* Start and end at zero size */
      opacity: 0.5;       /* Slightly transparent */
    }
    40% {
      transform: scale(1); /* Expand fully */
      opacity: 1;          /* Fully opaque */
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Componants/Loader/Loader.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,MAAM;IACN,OAAO;IACP,oCAAoC,EAAE,+CAA+C;IACrF,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS,EAAE,uBAAuB;EACpC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB,EAAE,iBAAiB;IAC5C,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE;MACE,mBAAmB,EAAE,+BAA+B;MACpD,YAAY,QAAQ,yBAAyB;IAC/C;IACA;MACE,mBAAmB,EAAE,iBAAiB;MACtC,UAAU,WAAW,iBAAiB;IACxC;EACF","sourcesContent":[".loader-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    width: 100vw;\n    position: fixed;\n    top: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.5); /* Darker transparent background for elegance */\n    z-index: 9999;\n  }\n  \n  .loader {\n    display: flex;\n    gap: 10px; /* Space between dots */\n  }\n  \n  .loader span {\n    width: 20px;\n    height: 20px;\n    background-color: #3498db; /* Loader color */\n    border-radius: 50%;\n    animation: pulse 1.5s infinite ease-in-out;\n  }\n  \n  .loader span:nth-child(1) {\n    animation-delay: 0s;\n  }\n  .loader span:nth-child(2) {\n    animation-delay: 0.2s;\n  }\n  .loader span:nth-child(3) {\n    animation-delay: 0.4s;\n  }\n  \n  @keyframes pulse {\n    0%, 80%, 100% {\n      transform: scale(0); /* Start and end at zero size */\n      opacity: 0.5;       /* Slightly transparent */\n    }\n    40% {\n      transform: scale(1); /* Expand fully */\n      opacity: 1;          /* Fully opaque */\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
